import { useState } from 'react';
import Instagram from '../../../assets/icons/trvto_instagram.svg';
import Whatsapp from '../../../assets/icons/trvto_whatsapp.svg';

export default function MessagesTab({ user, sendMessage, messages = [] }) {
    const [message, setMessage] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState('');

    const handleTemplateChange = (e) => {
        const value = e.target.value;

        setSelectedTemplate(value);

        switch (value) {
            case 'trip':
                setMessage('Hi 👋\n\nHere are the trip details you requested.\n\n');

                break;

            case 'payment':
                setMessage('Hi 👋\n\nThis is a reminder to complete your booking payment.');

                break;

            case 'followup':
                setMessage("Hi 👋\n\nJust checking if you're still interested in the trip.");

                break;

            case 'booking':
                setMessage('🎉 Your booking has been confirmed.\n\nThank you for choosing TRVTO.');

                break;

            default:
                setMessage('');
        }
    };

    return (
        <div className='messagesTab'>
            <div className='messagesHeader'>
                <div>
                    <h3>Send Message</h3>
                    <p>Send a WhatsApp/Instagram message to the customer.</p>
                </div>

                <div className='platformChip'>
                    <img src={user.platform === 'instagram' ? Instagram : Whatsapp} width={18} alt='' />

                    <span style={{ textTransform: 'capitalize' }}>{user.platform}</span>
                </div>
            </div>

            <div className='fieldGroup'>
                <label>Quick Template</label>

                <select value={selectedTemplate} onChange={handleTemplateChange}>
                    <option value=''>Select Template</option>
                    <option value='trip'>Trip Details</option>
                    <option value='followup'>Follow Up</option>
                    <option value='payment'>Payment Reminder</option>
                    <option value='booking'>Booking Confirmation</option>
                    <option value='custom'>Custom</option>
                </select>
            </div>

            <div className='fieldGroup'>
                <label>Message</label>

                <textarea
                    className='messageBox'
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    maxLength={1000}
                    placeholder='Type your message...'
                />

                <div className='messageFooter'>
                    <span>{message.length}/1000</span>
                </div>
            </div>

            <button
                className='sendBtn'
                onClick={() => {
                    sendMessage(message);
                    setMessage('');
                    setSelectedTemplate('');
                }}
            >
                <img src={user.platform === 'instagram' ? Instagram : Whatsapp} width={18} alt='' />
                Send Message
            </button>

            {/* <div className='recentSection'>
                <h4>Recent Messages</h4>

                {messages.length ? (
                    messages.map((item) => (
                        <div className='sentBubble' key={item._id}>
                            <div className='sentTop'>
                                <strong>{item.sentBy?.name || 'Admin'}</strong>

                                <span>{new Date(item.createdAt).toLocaleString()}</span>
                            </div>

                            <p>{item.message}</p>
                        </div>
                    ))
                ) : (
                    <div className='emptyComments'>No messages sent yet.</div>
                )}
            </div> */}
        </div>
    );
}
